/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HookCondition
 */
export interface HookCondition {
    /**
     * 
     * @type {string}
     * @memberof HookCondition
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HookCondition
     */
    field: string;
    /**
     * 
     * @type {string}
     * @memberof HookCondition
     */
    operator: HookConditionOperatorEnum;
    /**
     * String representation of the comparison value. Will be converted to appropriate type for comparison. For field-comparison operators (ending with _field), this should be the name of another field to compare against.
     * @type {string}
     * @memberof HookCondition
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof HookCondition
     */
    logical_operator?: HookConditionLogicalOperatorEnum;
}


/**
 * @export
 */
export const HookConditionOperatorEnum = {
    Equals: 'equals',
    NotEquals: 'not_equals',
    Contains: 'contains',
    NotContains: 'not_contains',
    GreaterThan: 'greater_than',
    LessThan: 'less_than',
    Exists: 'exists',
    NotExists: 'not_exists',
    EqualsField: 'equals_field',
    NotEqualsField: 'not_equals_field',
    ContainsField: 'contains_field',
    NotContainsField: 'not_contains_field',
    GreaterThanField: 'greater_than_field',
    LessThanField: 'less_than_field'
} as const;
export type HookConditionOperatorEnum = typeof HookConditionOperatorEnum[keyof typeof HookConditionOperatorEnum];

/**
 * @export
 */
export const HookConditionLogicalOperatorEnum = {
    And: 'and',
    Or: 'or'
} as const;
export type HookConditionLogicalOperatorEnum = typeof HookConditionLogicalOperatorEnum[keyof typeof HookConditionLogicalOperatorEnum];


/**
 * Check if a given object implements the HookCondition interface.
 */
export function instanceOfHookCondition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "operator" in value;

    return isInstance;
}

export function HookConditionFromJSON(json: any): HookCondition {
    return HookConditionFromJSONTyped(json, false);
}

export function HookConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): HookCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'field': json['field'],
        'operator': json['operator'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'logical_operator': !exists(json, 'logical_operator') ? undefined : json['logical_operator'],
    };
}

export function HookConditionToJSON(value?: HookCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'field': value.field,
        'operator': value.operator,
        'value': value.value,
        'logical_operator': value.logical_operator,
    };
}

